// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container-table {
    overflow: auto;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.issues-table {
    border-collapse: collapse;
    width: 100%;
    display: grid;
    padding-bottom: 5px;
}

.issues-table-header-row {
    border-bottom: 1px solid;
    display: flex;
    align-items: center;
    width: 100%;
    color: var(--ds-text-subtlest, var(--local-dynamic-table-text-color));
    font-weight: 600;
    font-size: 12px;
    background-color: var(--ds-surface, #ffffff);
    border-color: var(--ds-border, #091e4224);
}

.issues-table-body {
    display: flex;
    position: relative;
}

.issues-table-header {
    display: grid;
    position: sticky;
    background-color: var(--ds-surface-overlay, #ffffff);
    top: 0;
    z-index: 1;
    padding: 0 1px;
}

.issues-table-header-cell {
    display: flex;
}

.issues-table-header-cell .check-all {
    margin-left: 1px;
}

.flex-center {
    align-items: center;
    display: flex;
}

.issues-table-row {
    box-sizing: border-box;
    border-bottom: 1px solid;
    border-right: 1px solid;
    border-left: 1px solid;
    display: flex;
    position: absolute;
    align-items: center;
    height: 34px;
    width: 100%;
    border-color: var(--ds-border, #091e4224);
}

.issues-table-row.selected:hover {
    background-color: var(--ds-background-selected-hovered, #09326c);
}

.issues-table-row.selected {
    background-color: var(--ds-background-selected, #deebff);
}

.issues-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
}

.issues-table-cell > [role="presentation"] {
    display: flex;
}

.issues-table-cell,
.issues-table-header-cell {
    padding: var(--ds-space-050, 4px) var(--ds-space-100, 8px);
}

.issues-table-header-cell.summary,
.issues-table-cell.summary {
    flex-grow: 1;
    min-width: 300px;
}

.issues-table-cell.game_estimation {
    height: 100%;
    border-right: 1px dashed var(--ds-border-discovery, #8f7ee7);
    display: flex;
    justify-content: center;
    align-items: center;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#container-table:not([dragging="true"]) .issues-table-row:not(.selected):hover {
    background: var(--ds-background-neutral-subtle-hovered, #fafbfc);
}

.dragging {
    background: var(--ds-background-selected-hovered, #deebff);
}

.dragging:after {
    content: "";
    display: block;
    position: absolute;
    z-index: var(--z-index-layer-4);
    inset: 1px;
    box-shadow: 0 0 0 2px var(--ds-border-focused, #2684ff);
    pointer-events: none;
}

.hoverable-checkboxes .hoverable-checkbox {
    opacity: 0;
}

.hoverable-checkboxes .issues-table-row:hover .hoverable-checkbox,
.hoverable-checkboxes .hoverable-checkbox:hover {
    opacity: 1;
}

.empty-items-table {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 100px;
}

.empty-items-table img {
    padding: 26px;
}

.issues-table-cell.user {
    display: flex;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/backlog/table.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qEAAqE;IACrE,gBAAgB;IAChB,eAAe;IACf,4CAA4C;IAC5C,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,oDAAoD;IACpD,MAAM;IACN,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,0DAA0D;AAC9D;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,4DAA4D;IAC5D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;IACV,uDAAuD;IACvD,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B","sourcesContent":["#container-table {\n    overflow: auto;\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.issues-table {\n    border-collapse: collapse;\n    width: 100%;\n    display: grid;\n    padding-bottom: 5px;\n}\n\n.issues-table-header-row {\n    border-bottom: 1px solid;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    color: var(--ds-text-subtlest, var(--local-dynamic-table-text-color));\n    font-weight: 600;\n    font-size: 12px;\n    background-color: var(--ds-surface, #ffffff);\n    border-color: var(--ds-border, #091e4224);\n}\n\n.issues-table-body {\n    display: flex;\n    position: relative;\n}\n\n.issues-table-header {\n    display: grid;\n    position: sticky;\n    background-color: var(--ds-surface-overlay, #ffffff);\n    top: 0;\n    z-index: 1;\n    padding: 0 1px;\n}\n\n.issues-table-header-cell {\n    display: flex;\n}\n\n.issues-table-header-cell .check-all {\n    margin-left: 1px;\n}\n\n.flex-center {\n    align-items: center;\n    display: flex;\n}\n\n.issues-table-row {\n    box-sizing: border-box;\n    border-bottom: 1px solid;\n    border-right: 1px solid;\n    border-left: 1px solid;\n    display: flex;\n    position: absolute;\n    align-items: center;\n    height: 34px;\n    width: 100%;\n    border-color: var(--ds-border, #091e4224);\n}\n\n.issues-table-row.selected:hover {\n    background-color: var(--ds-background-selected-hovered, #09326c);\n}\n\n.issues-table-row.selected {\n    background-color: var(--ds-background-selected, #deebff);\n}\n\n.issues-table-cell {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: inline-block;\n}\n\n.issues-table-cell > [role=\"presentation\"] {\n    display: flex;\n}\n\n.issues-table-cell,\n.issues-table-header-cell {\n    padding: var(--ds-space-050, 4px) var(--ds-space-100, 8px);\n}\n\n.issues-table-header-cell.summary,\n.issues-table-cell.summary {\n    flex-grow: 1;\n    min-width: 300px;\n}\n\n.issues-table-cell.game_estimation {\n    height: 100%;\n    border-right: 1px dashed var(--ds-border-discovery, #8f7ee7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.ellipsis {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n#container-table:not([dragging=\"true\"]) .issues-table-row:not(.selected):hover {\n    background: var(--ds-background-neutral-subtle-hovered, #fafbfc);\n}\n\n.dragging {\n    background: var(--ds-background-selected-hovered, #deebff);\n}\n\n.dragging:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    z-index: var(--z-index-layer-4);\n    inset: 1px;\n    box-shadow: 0 0 0 2px var(--ds-border-focused, #2684ff);\n    pointer-events: none;\n}\n\n.hoverable-checkboxes .hoverable-checkbox {\n    opacity: 0;\n}\n\n.hoverable-checkboxes .issues-table-row:hover .hoverable-checkbox,\n.hoverable-checkboxes .hoverable-checkbox:hover {\n    opacity: 1;\n}\n\n.empty-items-table {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    margin-top: 100px;\n}\n\n.empty-items-table img {\n    padding: 26px;\n}\n\n.issues-table-cell.user {\n    display: flex;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
